<template>
	<v-container class="pt-6">
	  <v-row justify="center">

	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" sm="8" md="6" lg="6" class="pb-1 mt-15">
	  		<v-card class="elevation-0 shadowCard">
	  			<v-card-text>
	  				<v-row>
	  					<v-col cols="9">
	  						<div>
			            <p class="mb-0 font-weight-bold">
			              {{ getGrupo.grupo.grupo_corto }}
			            </p>

			            <h5 class="mb-0 font-weight-bold text-h6 colorCurso" >
			              {{ getGrupo.escuela.curso }}<br/>
			            </h5>
		              <span class="text-sm font-weight-bolder grey--text">
		                <strong>{{ getGrupo.grupo.hora_inicio }} a {{ getGrupo.grupo.hora_fin }}</strong>
		              </span>
			          </div>
	  					</v-col>

	  					<v-col cols="2">
		            <v-avatar
			            size="60"
			            color="transparent"
			            rounded
			            class="elevation-1 avatares shadowCard"
			          >
			            <span class="text-h4 white--text">{{ getGrupo.grupo.id_nivel }}</span>
			          </v-avatar>
	  					</v-col>
	  				</v-row>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <v-row justify="center">
	  	<!-- Boton para ir a los recusos -->
	  	<v-col cols="12" sm="8" md="6" lg="6" class="pb-1">
	  		<v-card class="shadowCard">
		  		<v-list flat>
		  			<v-subheader>Lista de alumnos</v-subheader>
			      <v-list-item-group
			        v-model="model"
			        color="primary"
			      >
			        <v-list-item
			          v-for="(alumno, i) in listaalumnos"
			          :key="i"
			        >
			          <v-list-item-icon>
				        	<v-avatar
				        	  size="42"
				        	  color="transparent"
				        	>
				            <avataaars
				            	v-if="alumno.idavatar != null"
					          	:accessoriesType="alumno.accessoriesType"
						        	:isCircle="true"
								      :clotheType="alumno.clotheType"
						        	:clotheColor="alumno.clotheColor"
								      :eyebrowType="alumno.eyebrowType"
								      :eyeType="alumno.eyeType"
								      :facialHairColor="alumno.facialHairColor"
						        	:facialHairType="alumno.facialHairType"
								      :graphicType="alumno.graphicType"
								      :mouthType="alumno.mouthType"
						        	:skinColor="alumno.skinColor"
						        	:topType="alumno.topType"
						        	:topColor="alumno.topColor"
								      :hairColor="alumno.hairColor"
								      :circleColor="'#6fb8e0'">
								    </avataaars>
							    	<avataaars v-else></avataaars>
				        	</v-avatar>
			          </v-list-item-icon>

			          <v-list-item-content>
			            <v-list-item-title >
			            	<span class="text-caption">{{ alumno.alumno }}</span>
			            </v-list-item-title>
			          </v-list-item-content>
			        </v-list-item>
			      </v-list-item-group>
			    </v-list>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	  <v-speed-dial
      top
      left
      absolute
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          :to="{ name: 'DetalleGrupoTeacher' }"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'

  import Avataaars     from 'vuejs-avataaars'
  
  const  base64 = require('base-64');

	export default {
	  name: "dashboard-default",
	  data: () => ({
    	respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	listaalumnos: [],
      model: null,
	  }),

	  components: {
	    Alerta,
	    Loader,
	    Avataaars
	  },

	  async created ( ){
    	await this.getAlumnos( )
    },

    
	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirCalificaciones' ] ),

	  	getAlumnos ( ){
    		this.cargar = true
  			// Preparamos el id del teacher
    		const id_grupo = base64.encode( this.getGrupo.grupo.id )
  			// Hacemos la consulta
    		this.$http.get('grupos.lista.alumnos/' + id_grupo ).then( response=> {
    			this.listaalumnos = response.body
    		}).catch( error =>{
    			this.validarError( error )
    		}).finally( () => { this.cargar = false })
    	},

    	validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

	.recursos{
		background: rgb(233,186,255);
		background: linear-gradient(90deg, rgba(233,186,255,1) 0%, rgba(186,52,251,1) 100%);
	}

	.calificaciones{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.colorCurso{
		color: #006093;
	}

</style>
